import { useEffect, useReducer } from 'react';

import { getPublicStockCustomMetrics } from '../api';

const initialPublicMetricCountState = {
  count: 0,
};

function publicMetricCountReducer(state, action) {
  switch (action.type) {
    case 'reset':
      return initialPublicMetricCountState;
    case 'loaded':
      return { count: action.count };
    case 'failed':
      return initialPublicMetricCountState;
    default:
      return state;
  }
}

export function usePublicStockMetricCount(ticker) {
  const [state, dispatch] = useReducer(
    publicMetricCountReducer,
    initialPublicMetricCountState
  );

  useEffect(() => {
    if (!ticker) {
      dispatch({ type: 'reset' });
      return undefined;
    }

    let cancelled = false;

    async function fetchPublicMetrics() {
      try {
        const payload = await getPublicStockCustomMetrics(ticker);
        if (cancelled) return;
        const metrics = Array.isArray(payload?.metrics) ? payload.metrics : [];
        dispatch({ type: 'loaded', count: metrics.length });
      } catch {
        if (!cancelled) {
          dispatch({ type: 'failed' });
        }
      }
    }

    fetchPublicMetrics();

    return () => {
      cancelled = true;
    };
  }, [ticker]);

  return state.count;
}
